import { createInfiniteHitsSessionStorageCache } from "instantsearch.js/es/lib/infiniteHitsCache";

/**
 * useInfiniteHits 의 cache 옵션에 넘길 sessionStorage 캐시. cacheKey 당 하나를 재사용한다.
 *
 * 목록 → 상세 → 뒤로가기로 돌아올 때 InstantSearch 상태는 마운트마다 새로 시작하고
 * algoliasearch v5 는 응답 캐시가 없어서, 캐시가 없으면 첫 렌더가 빈 목록이 된다.
 * 그러면 문서 높이가 없어 브라우저 스크롤 복원이 맨 위로 떨어진다.
 *
 * 저장 실패(용량 초과 등)는 instantsearch 가 조용히 무시하고 네트워크로 폴백한다.
 */
const hitsCaches = new Map<string, ReturnType<typeof createInfiniteHitsSessionStorageCache>>();

export function getInfiniteHitsCache(cacheKey?: string) {
  if (!cacheKey) return undefined;
  if (!hitsCaches.has(cacheKey)) hitsCaches.set(cacheKey, createInfiniteHitsSessionStorageCache({ key: cacheKey }));

  return hitsCaches.get(cacheKey);
}
